<ng-container *ngIf="withReactiveForms">
  <label *ngIf="fieldLabel" for="{{ fieldId }}">
    {{ fieldLabel }}
    <span *ngIf="isRequired" class="required">*</span>
    <span *ngIf="toolTipText"
      [matTooltip]="toolTipText" matTooltipPosition="above">
      <mat-icon color="primary">info</mat-icon>
    </span>
  </label>
  <mat-form-field>
    <input
      [id]="fieldId"
      matInput
      [matDatepicker]="picker"
      [disabled]="disabled"
      [(ngModel)]="value"
      floatPlaceholder="never"
      [placeholder]="getPlaceHolderValue(value)" i18n-placeholder
      [min]="minDate"
      [max]="maxDate"
      (ngModelChange)="innerModelChanged()"
      (blur)="onTouchedCallback()">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker [startAt]="startAt"></mat-datepicker>
  </mat-form-field>
</ng-container>

<ng-container *ngIf="!withReactiveForms">
  <form [formGroup]="datePickerForm" novalidate>
    <label *ngIf="fieldLabel" for="{{ fieldId }}">{{ fieldLabel }}<span *ngIf="isRequired" class="required">*</span>
      <span *ngIf="toolTipText"
        [matTooltip]="toolTipText" matTooltipPosition="above">
        <mat-icon color="primary">info</mat-icon>
      </span>
    </label>
    <mat-form-field [floatLabel]="floatLabel">
      <input
        [id]="fieldId"
        matInput
        [matDatepicker]="picker"
        floatPlaceholder="never"
        [formControlName]="datePickerObject.key"
        [placeholder]="getPlaceHolderValue(datePickerObject?.value)" i18n-placeholder
        [min]="minDate"
        [max]="maxDate"
        (input)="inputDatePicker($event)">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker [startAt]="startAt"></mat-datepicker>
    </mat-form-field>
  </form>
</ng-container>
